import { makeStyles } from '@material-ui/core/styles';

const containerDefault = {
  display: 'flex',
  flexDirection: 'row',
  gap: '1rem',
  justifyContent: 'flex-start',
  height: '100%',
  width: '100%',
  boxSizing: 'border-box',
  padding: '2rem',
};

const useStyles = makeStyles((theme) => ({
  container: {
    ...containerDefault,
    backgroundColor: theme.palette.container.background,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  scrollableContainer: {
    ...containerDefault,
    paddingRight: '0rem',
    backgroundColor: theme.palette.container.background,
  },
  scrollableContainerColumn: {
    ...containerDefault,
    backgroundColor: theme.palette.container.background,
    paddingRight: '0rem',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  textHeader: {
    color: theme.palette.secondary.main,
    fontSize: '1.25rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    marginBottom: '1rem',
    marginTop: '2rem',
  },
  label: {
    fontSize: '1.125rem',
    fontWeight: '600',
    textTransform: 'uppercase',
  },
  headerSwitch: {
    display: 'flex',
    alignItems: 'center',
  },
  textField: {
    fontSize: '1.25rem',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  irthConfig: {
    marginLeft: '0.5rem',
  },
}));

export default useStyles;
